import { useLocation } from "react-router-dom";

const tabs = [
  { label: "Dashboard", href: "/admin/crm", id: "crm-tab-dashboard" },
  { label: "Carriers", href: "/admin/crm/carriers", id: "crm-tab-carriers" },
  { label: "Loads", href: "/admin/crm/loads", id: "crm-tab-loads" },
  { label: "Documents", href: "/admin/crm/documents", id: "crm-tab-documents" },
  { label: "Follow-ups", href: "/admin/crm/followups", id: "crm-tab-followups" },
  { label: "Invoices", href: "/admin/crm/invoices", id: "crm-tab-invoices" },
];

export const CrmTabs = () => {
  const { pathname } = useLocation();
  return (
    <div className="border-b border-white/10 overflow-x-auto" data-testid="crm-tabs">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex gap-1 min-w-max">
        {tabs.map((t) => {
          const active = t.href === "/admin/crm" ? pathname === t.href : pathname.startsWith(t.href);
          return (
            <a
              key={t.href}
              href={t.href}
              data-testid={t.id}
              className={`font-mono text-[10px] uppercase tracking-[0.2em] px-4 py-3 transition-colors duration-300 ${
                active ? "text-white bg-white/5 border-b-2 border-white" : "text-neutral-500 hover:text-white"
              }`}
            >
              {t.label}
            </a>
          );
        })}
      </div>
    </div>
  );
};
